module.exports = __webpack_public_path__ + "img/ico-stroke-90-x-90.e0e75448.svg";